import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { withRouter } from 'kts-platform-frame/routes';
import Action from './Modules.Action.record';
import { Field } from 'kts-scaffold-framework/utils/doc';
import Filter from './UI.AuthLogging.Filter';
import {removeLoading} from 'kts-platform-frame/service/Tools';
import moment from 'moment';
import InfiniteScroll from 'kts-scaffold-framework/component/InfiniteScroll';
import { Table, Tag, Button, Col, Row, Tooltip, message } from 'antd';
import server from 'kts-platform-frame/service';
import { MyStore, reducers } from 'kts-platform-frame/redux';
import { authManage } from '../../../api';
import { Urls } from 'kts-platform-frame/entry/constant';
const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
    random?: number;
}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
@withRouter
export default class AuthRecord extends UIBasic<IProps, ModulesState> {
    public scroller: InfiniteScroll;
    public columns = [
        {
            title: '',
            dataIndex: 'invoiceType',
            className: 'text-center ant-td-status',
            width: 40,
            render: (text, record) => {
                return (
                    <div className="ui-item-icon input-type bg-green">
                        {this.typeDesc(text)}
                    </div>
                );
            }
        },
        {
            title: '',
            dataIndex: 'ocrState',
            className: 'text-center',
            width: 40,
            render: (text, record) => {
                return (
                    <div>
                        {this.creatIcon(record)}
                    </div>
                );
            }
        },
        {
            title: '文件名',
            dataIndex: 'orgFileName',
            className: 'text-center',
            width: 100,
            render: (text, record) => {
                return (
                    <div>
                        {text}
                    </div>
                );
            }
        },
        {
            title: '发票代码',
            dataIndex: 'invoiceCode',
            width: 100,
            className: 'text-center',
            render: (text) => {
                return <span> {text} </span>;
            }
        },

        {
            title: '发票号码',
            dataIndex: 'invoiceNumber',
            width: 100,
            className: 'text-center',
            render: (text, record) => {
                return <span>{text}</span>;
            }
        },
        {
            title: '含税金额',
            dataIndex: 'erpAmountTaxTotal',
            className: 'text-center',
            width: 90,
            render: (text, record) => {
                return <span>{text ? ('¥' + Field.formatMoney(text, 2)) : '——'}</span>;
            }
        },
        {
            title: '税额',
            dataIndex: 'erpTaxTotal',
            className: 'text-center',
            width: 90,
            render: (text, record) => {
                return <span>{text ? ('¥' + Field.formatMoney(text, 2)) : '——'}</span>;
            }
        },
        {
            title: '原发票号码',
            dataIndex: 'erpInvoiceNumber',
            className: 'text-center',
            width: 110,
            render: (text, record) => {
                return <span>{text}</span>;
            }
        },


        {
            title: '录入时间',
            dataIndex: 'inputTime',
            className: 'text-center',
            width: 100,
            render: (text, record) => {
                return (
                    <div>
                        {moment(text).format('YYYY-MM-DD HH:mm:ss')}
                    </div>
                );
            }
        },
        {
            title: '录入用户',
            dataIndex: 'inputOperatorName',
            className: 'text-center',
            width: 100,
            render: (text, record) => {
                return <span>{text}</span>;
            }
        },
        {
            title: '勾选结果',
            dataIndex: 'draftState',
            className: 'text-center',
            width: 100,
            render: (text, record) => {
                return <span>
                    {text === 0 && '未处理'}
                    {text === 1 && '失败'}
                    {text === 2 && '成功'}
                </span>;
            }
        },
        {
            title: '异常描述',
            dataIndex: 'draftMsg',
            className: 'text-center',
            width: 100,
            render: (text, record) => {
                return <span>{text}</span>;
            }
        },
        {
            title: '录入方式',
            dataIndex: 'inputType',
            width: 100,
            className: 'text-center',
            render: (text, record) => {
                return (<span>
                    {text === 3 && '手动'}
                    {text === 1 && '扫描枪'}
                    {text === 5 && '影像文件'}
                    {text === 2 && '扫描仪'}
                    {text === 4 && 'excel上传'}
                    {text === 6 && 'api录入'}
                </span>);
            }
        },
        {
            title: '操作',
            dataIndex: 'operation',
            width:87,
            className: 'text-center',
            render: (text, record) => {
                return (
                    <div className="text-center input-time">
                        {
                            (record.inputType === 5 || record.inputType === 2) &&
                            <span className="pd5 hand" style={{ color: '#1A91EB' }} onClick={() => { this.viewImage(record); }}>影像</span>}
                    </div>
                );
            }
        },
    ];
    constructor(props: IProps) {
        super(props, ModulesAction);
        this.state = {
            hasMore: true,
            loading: false,
            refresh: false,
            modal: false,
            total: 0
        };
    }
    creatIcon = (record) => {
        let warnMessage = '';
        let icontype = ''; // 正确 
        let color = '#72b148';

        if (record.inputType === 2 || record.inputType === 5) {
            if (record.ocrState === 2) {

            } else if (record.ocrState === 1) {
                color = '#f5222d';
                icontype = 'anticon-fapiaoyichang'; // 异常
                warnMessage = '未识别';
            }
            else {
                icontype = 'anticon-icon-test'; // 漏斗
                color = '#BCC7D3';
                warnMessage = '识别中';
            }

            return (
                <Tooltip title={warnMessage}>
                    <i className={`anticon ${icontype}`} style={{ color: color }} />
                </Tooltip>
            );
        } else {

            if (record.erpExcelParseResult === '1') {
                color = '#f5222d';
                icontype = 'anticon-fapiaoyichang';
                warnMessage = '解析异常';
                return (
                    <Tooltip title={warnMessage}>
                        <i className={`anticon ${icontype}`} style={{ color: color }} />
                    </Tooltip>
                );
            } else {
                return '';
            }

        }
    }
    typeDesc = (str: any) => {
        switch (str) {
            case 5:
                return '机';
            case 1:
                return '未';
            case 2:
                return '专';
            case 3:
                return '普';
            case 6:
                return '电';
            case 7:
                return '卷';
            case 8:
                return '通';
            case 4:
                return '货';
            default:
                return '普';
        }
    }
    viewImage = (record) => {
        let data = this.modulesState.loggingList.filter(item => item.inputType === 5);
        let inputIds = data.map((item) => item.inputId);
        this.props.history.push({ pathname: `/workbench/authManage/authlogging/addshadow/${record.inputId}`, state: inputIds });
    }
    componentDidMount() {
        this.getData();
        ModulesAction.updateCount();
    }
    downloadHandler = async () => {
        const { total } = this.state;
        if (total > 5000) {
            message.error("您筛选的数据超过5000条，请确保筛选少于5000条数据后导出。");
            return false;
        }
        let data = await server.post(Urls.downloadList, {
            ...this.modulesState.loggingFields
        }).resFs([removeLoading]).responseType("blob").end(null);
        const blob = data.res.body;
        const downloadUrl = URL.createObjectURL(blob);  
        const a = document.createElement("a");
        a.href = downloadUrl;
        a.download = `deductionExport_${moment(new Date()).format("YYYYMMDDHHmmss")}.xls`;
        a.click();
    }
    getData = () => {
        this.setState({
            loading: true
        });
        authManage.authLoggingList(this, {
            pageNum: this.modulesState.loggingPageNum,
            pageSize: this.modulesState.loggingPageSize,
            ...this.modulesState.loggingFields,
        }).then((response: any) => {
            const res = response.res;
            if (res) {
                let list = this.modulesState.loggingList;
                this.modulesState.loggingList = list.concat(res.items);
                this.modulesState.loggingPageNum = res.pageMeta.pageNum + 1;
                ModulesAction.setModulesState();
                if (res.pageMeta.pageNum * res.pageMeta.pageSize > res.pageMeta.total) {
                    this.setState({
                        hasMore: false,
                    });
                }
                this.setState({
                    loading: false,
                    total: res.pageMeta.total
                });
            }
        });
    }
    handleRefresh = () => {
        this.modulesState.loggingList = [];
        this.modulesState.loggingPageNum = 1;
        ModulesAction.setModulesState();
        this.setState({
            hasMore: true,
            loading: false,
        });
        this.getData();
        ModulesAction.updateCount();
    }
    clearState = () => {

    }
    componentWillUnmount() {
        this.clearState();
    }
    footerDom = () => {
        const { total } = this.state;
        return (
            <div style={{ overflow: 'hidden' }}>
                <div className="pull-left">合计</div>
                <span className="pull-right mr10" onClick={() => { this.scroller.toTop(); }}>
                    <Button icon="huidaodingbuanniu" shape="circle" size='small' style={{ color: '#99A9BF' }} />
                </span>
                <div className="pull-right mr10">记录数:{total}</div>

            </div>
        );
    }
    refreshInvoice = () => {
        this.modulesState.loggingList = [];
        this.modulesState.loggingPageNum = 1;
        ModulesAction.setModulesState();
        this.setState({
            hasMore: true,
            loading: false
        }, () => { this.getData(); });

    }
    toggleFilter = () => {
        MyStore.instance.dispatch(reducers.rightPopUps.ActionTypes.add, {
            Components: <Filter
                getData={this.refreshInvoice}
            />,
            title: '筛选'
        });
    }
    render() {
        const { loggingList } = this.modulesState;
        const { modal, loading, hasMore } = this.state;
        const dataSource =
            loggingList.map((item, index) => {
                return {
                    ...item,
                    index
                };
            });
        return (
            <div style={{ height: 'calc(100% - 60px)' }}>
                <Row className={`${css['invoice-card-hander']}`}>
                    <Col span={12}>
                        <Button className="mr10" type="primary" onClick={() => { ModulesAction.showDeductionInPanel(this.handleRefresh); }}>
                            认证录入
                        </Button>
                        <Button className="mr10" type="primary" onClick={this.downloadHandler}>
                            导出记录
                        </Button>
                    </Col>
                    <Col span={12} className="text-right">
                        <Button className="ml10" onClick={this.toggleFilter} icon="filter">
                            筛选
                        </Button>
                        <Button className="ml10" icon="sync" onClick={this.handleRefresh}>
                        </Button>
                    </Col>
                </Row>
                <div style={{ height: 'calc(100vh - 111px)', overflow: 'auto' }}>
                    <InfiniteScroll
                        loadMore={this.getData}
                        hasMore={!loading && hasMore}
                        ref={(target) => { this.scroller = target; }}
                    >
                        <Table
                            columns={this.columns}
                            className="ui-list"
                            dataSource={dataSource}
                            rowKey='index'
                            rowClassName={() => 'ui-item doc-item'}
                            pagination={false}
                            bordered={true}
                            footer={() => { return this.footerDom(); }}
                            scroll={{ y: 'calc(100vh - 218px)' }}
                        />
                    </InfiniteScroll>
                </div>

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/display/apps/AuthManage/UI.AuthLogging.List.tsx